import { Button } from '@simplywallst/ui-core';
import { useCreateNotesSidebar } from '../../../hooks/useCreateNotesSidebar';
import { useOverviewTranslation } from '../../OverviewSection/hooks/useOverviewTranslation';

interface Props {
  companyId?: string;
  uniqueSymbol?: string;
  trackEvent: (event: { action: string; modifier: string }) => void;
}

const SeeMoreButton = ({ companyId, uniqueSymbol, trackEvent }: Props) => {
  const { openSidebar, isSidebarShowing } = useCreateNotesSidebar({
    companyId,
    uniqueSymbol,
  });

  const t = useOverviewTranslation();

  return (
    <Button
      data-cy-id="my-notes-see-more"
      disabled={isSidebarShowing}
      display="block"
      onClick={() => {
        openSidebar();
        trackEvent({
          action: 'click',
          modifier: 'see-more',
        });
      }}
      styleType="loud"
    >
      {t('myNotes.seeMore')}
    </Button>
  );
};

export default SeeMoreButton;
